import SubsectionCard from "../../WritingGradeSection/SubsectionCard";

const PatientCenteredCommunicationSection = ({
  patientCenteredCommunication,
}) => {
  const empathyAndRapport = patientCenteredCommunication["empathy_and_rapport"];
  const patientClientInvolvementInDecisionMaking =
    patientCenteredCommunication[
      "patient_client_involvement_in_decision_making"
    ];

  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Patient-Centered Communication - Score{" "}
          {patientCenteredCommunication.total}/20
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <div className="writingGradeSectionSubsectionWrapper">
          <SubsectionCard
            title={"Empathy and Rapport"}
            score={`${empathyAndRapport.score}/5`}
            subTitle={"Comments"}
            subContent={empathyAndRapport.comments}
          />
          <SubsectionCard
            title={"Patient Client Involvement in Decision Making"}
            score={`${patientClientInvolvementInDecisionMaking.score}/5`}
            subTitle={"Comments"}
            subContent={patientClientInvolvementInDecisionMaking.comments}
          />
        </div>
        <div className="writingGradeSectionScoreText">
          Score: {patientCenteredCommunication.total}/10
        </div>
      </div>
    </div>
  );
};

export default PatientCenteredCommunicationSection;
